export const NIBInstructions: string = "NIB Instructions"; 
export const NIBQuoteRequest : string  ="NIB Quote Request"; 
export const RRInstructions : string = "RR Instructions"; 
export const RRQuoteRequest : string = "RR Quote Request"; 
export const Mk3Instructions : string = "Mk3 Instructions"; 
export const AppId: number = 11;
export const DocumentUploadPermission : number[] =[46,258];// Michael Doran,Troy McFadden
export const FileTypes =['pdf','png','gif','jpg','jpeg'];
export const PdfType ="application/pdf";
//export const ActionRequiredForSA = "Michael Gardiner";
export const ActionRequiredForSA = "Paul Harman";
export const LargeLossApproval = "Jace Thimios";
export const Success = "Success";
//export const LislEmail ='lisl.dobson@mk3.com.au';
export const SaifEmail ='saifuddin.faizi@mk3.com.au';
export const OliviaEmail ='olivia.figures@mk3.com.au';
export const OperationsManagerEmail ='jack.morgan@mk3.com.au';
export const NationalClaimsManagerEmail ='mitch.seymour@mk3.com.au';